// extracted by mini-css-extract-plugin
export default {"gradeScaleContainer":"GradeScaleDetailModal__gradeScaleContainer___PyvZI"};